import "./ChakraHealing.module.css";
import Header from "@/reusable_sections/Header";
import Chakras from "./sections/Chakras";
import WasIstChakraHeilung from "./sections/WasIstChakraHeilung";
import ChakraGalerie from "./sections/ChakraGalerie";
import BenefitsProcess from "./sections/BenefitsProcess";
import PreiseTermine from "./sections/PreiseTermine";
import Footer from "@/reusable_sections/Footer";
export default function ChakraHealingPage() {
  return <div>
      <Header />
      <Chakras />
      <WasIstChakraHeilung />
      <ChakraGalerie />
      <BenefitsProcess />
      <PreiseTermine />
      <Footer />
    </div>;
}